module.exports = __webpack_public_path__ + "media/ensor.f73345e0.mp4";